function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M7.141 8.897V3.704l4.863 2.606-4.863 2.587zM17.82 2.804s-.176-1.273-.715-1.834C16.42.233 15.653.23 15.3.187 12.782 0 9.004 0 9.004 0h-.008S5.218 0 2.7.187C2.347.23 1.58.233.895.97.355 1.53.18 2.804.18 2.804S0 4.3 0 5.796v1.402c0 1.496.18 2.991.18 2.991s.176 1.274.715 1.835c.685.736 1.585.713 1.985.79C4.32 12.956 9 13 9 13s3.782-.006 6.301-.193c.352-.043 1.119-.047 1.804-.783.539-.561.715-1.835.715-1.835S18 8.694 18 7.198V5.796c0-1.496-.18-2.992-.18-2.992z",
  fillRule: "evenodd"
});

function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 13",
    fill: "currentColor"
  }, props), _ref);
}

export default SvgYoutube;